import React from "react";
import { noormohammadProfilePic } from "../../assets";

const Banner = ({ theme }) => {
  return (
    <div
      className={` ${
        theme === "dark"
          ? "text-darkTextColor  border-darkLineColor"
          : "text-lightTextColor border-lightLineColor"
      } py-20 lgl:py-28 flex border-b-[1px] flex-col xl:flex-row gap-20 items-center justify-start`}
    >
      <div className="w-40 rounded-full h-40 relative flex justify-center items-center group">
        <div className="w-38 h-38 rounded-full overflow-hidden">
          <img
            className={`w-[150px] h-[150px] z-10 rounded-full border-2 group-hover:scale-110 duration-500 ${
              theme === "dark"
                ? "border-darkBgColor"
                : "border-lightTextDesignColor"
            }`}
            src={noormohammadProfilePic}
            alt="noormohammadProfilePic"
          />
        </div>
        <div
          className={`${
            theme === "dark" ? "border-lightBgColor" : "border-darkBgColor"
          } absolute border-[1px] rounded-full h-[135px] w-[135px] --left-5 top-3 animate-ping 
          group-hover:animate-none group-hover:border-transparent`}
        />
        {/* ============================ round One start ============================*/}
        <div className="absolute border border-gray-700 border-l-lightTextDesignColor border-r-lightTextDesignColor rounded-full h-[160px] w-[160px] -top-1.2 animate-reverse-spin-slow group-hover:animate-spin-slow"></div>
        {/* ============================ round One end ==============================*/}
        {/* ============================ round Two start ============================*/}

        <div className="absolute border border-t-lightTextDesignColor border-b-lightTextDesignColor border-blue-700 rounded-full h-[180px] w-[180px] -top-1.2 animate-spin-slow group-hover:animate-reverse-spin-slow"></div>
        {/* ============================ round Two end ==============================*/}
        {/* ============================ round Three start ==========================*/}

        <div className="absolute border border-t-lightTextDesignColor border-b-lightTextDesignColor hover:border--600 border-blue-700 rounded-full h-[200px] w-[200px] -top-1.2 animate-reverse-spin-slow group-hover:animate-spin-slow"></div>
        {/* ============================ round Three end ============================*/}
        {/* ============================ round Four start ============================*/}

        <div className="absolute border border-t-lightTextDesignColor border-b-lightTextDesignColor border-blue-700 rounded-full h-[220px] w-[220px] -top-1.2 animate-spin-slow group-hover:animate-reverse-spin-slow"></div>
        {/* ============================ round Four end ==============================*/}
      </div>
      <div className="flex flex-col gap-2">
        <h2 className="text-3xl lgl:text-[40px] text-center lgl:text-left font-semibold">
          Noor Mohammad
        </h2>
        <h3
          className={`font-medium ${
            theme === "dark"
              ? "text-transparent bg-gradient-to-r from-darkTextColor via-blue-600 to-darkTextColor"
              : "text-transparent bg-gradient-to-r from-lightTextColor via-blue-600 to-lightTextDesignColor"
          } text-center lgl:text-left text-2xl bg-clip-text lgl:text-3xl font-titleFont`}
        >
          Software Engineer
        </h3>
        <p
          className={`text-xl max-w-[1000px] text-center lgl:text-left ${
            theme === "dark"
              ? "text-darkTextColor font-light"
              : "text-lightTextColor font-medium"
          }`}
        >
          I'm a Software Engineer working at{" "}
          <a
            className="underline underline-offset-4 decoration-[1px] text-green-500 hover:text-green-400 duration-300"
            href="https://www.arogga.com/"
            target="_blank"
            rel="noreferrer"
          >
            arogga.com.
          </a>{" "}
          I specialized in Reactjs, React Native, Nextjs, Nodejs, Sanity.io,
          MongoDB, Tailwindcss, Expo and many more.
        </p>
      </div>
    </div>
  );
};

export default Banner;
